import React, { useRef, useState } from "react";
import { sendOtpLogin, verifyOtp } from "../api/loginApiService";
import { CustomSwal } from "../services/customSwal";
import { debug } from "console";


interface ContactVerificationModalProps {
    staffId: string | null;
    email?: string | null;
    EVerify?: string | null;
    mobile?: string | null;
    MVerify?: string | null;
    onClose: () => void;
    onVerified?: (type: "email" | "mobile", value: string) => void; // optional callback
}

const ContactVerification: React.FC<ContactVerificationModalProps> = ({
    staffId,
    email: initialEmail,
    EVerify,
    mobile: initialMobile,
    MVerify,
    onClose,
    onVerified,
}) => {
    const [email, setEmail] = useState(initialEmail || "");
    const [mobile, setMobile] = useState(initialMobile || "");
    const [emailStatus, setEmailStatus] = useState(EVerify);
    const [mobileStatus, setMobileStatus] = useState(MVerify);

    const [emailOtp, setEmailOtp] = useState("");
    const [mobileOtp, setMobileOtp] = useState("");

    const [showEmailOtp, setShowEmailOtp] = useState(false);
    const [showMobileOtp, setShowMobileOtp] = useState(false);
    const emailRef = useRef<HTMLInputElement>(null);
    const mobileRef = useRef<HTMLInputElement>(null);
    const handleSendOtp = async (type: "email" | "mobile") => {

        let receiver: string | undefined =
            type === "email" ? email ?? undefined : mobile ?? undefined;
        debugger;

        console.log('Otp receiver - ',receiver);
        if (!receiver) {
            await CustomSwal.fire({
                title: "Warning",
                text:
                    type === "email"
                        ? "Please enter email address."
                        : "Please enter mobile number.",
                icon: "warning",
                returnFocus: false,
            });

            setTimeout(() => {
                if (type === "email") {
                    emailRef.current?.focus();
                } else {
                    mobileRef.current?.focus();
                }
            }, 0);

            return;
        }


        if (
            type === "email" &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(receiver)
        ) {
            await CustomSwal.fire(
                "Invalid Email",
                "Please enter a valid email address.",
                "warning"
            );

            emailRef.current?.focus();
            return;
        }

        if (
            type === "mobile" &&
            !/^[6-9]\d{9}$/.test(receiver)
        ) {
            await CustomSwal.fire(
                "Invalid Mobile",
                "Please enter a valid 10-digit mobile number.",
                "warning"
            );

            mobileRef.current?.focus();
            return;
        }

        if (receiver.trim() != "") {
              const payload =
                type === "email"
                    ? { email: receiver }
                    : { mobile: receiver };

            const sendRes = await sendOtpLogin(payload);
            if (!receiver) {
                return;
            }


            if (type === "email") {
                setShowEmailOtp(true);
            } else {
                setShowMobileOtp(true);
            }
        }

    };

    const handleVerify = async (type: "email" | "mobile") => {
        const receiver =
            type === "email" ? email ?? undefined : mobile ?? undefined;

        if (!receiver || !staffId) return;

        const otp = type === "email" ? emailOtp : mobileOtp;

        if (!otp) {
            CustomSwal.fire("Warning", "Please enter the OTP.", "warning");
            return;
        }

        const payload =
            type === "email"
                ? { email: receiver }
                : { mobile: receiver };

        try {
            const verifyRes = await verifyOtp(payload, otp, staffId);

            if (verifyRes?.verified) {
                CustomSwal.fire(
                    "Verified",
                    `${type === "email" ? "Email" : "Mobile"} verified successfully.`,
                    "success"
                );

                if (type === "email") {
                    setEmailStatus("Y");
                    setShowEmailOtp(false);
                    sessionStorage.setItem("EVerify", "Y");
                    sessionStorage.setItem("EmailId", receiver);
                } else {
                    setMobileStatus("Y");
                    setShowMobileOtp(false);
                    sessionStorage.setItem("MVerify", "Y");
                    sessionStorage.setItem("Mobile", receiver);
                }
                console.log('Receiver - ',receiver);
                onVerified?.(type, receiver);

                // Close the modal if both email and mobile are verified
                const emailVerified =
                    type === "email" ? true : emailStatus === "Y";
                const mobileVerified =
                    type === "mobile" ? true : mobileStatus === "Y";

                if (emailVerified && mobileVerified) {                   
                    onClose();
                }
            } else {
                CustomSwal.fire(
                    "Verification Failed",
                    "Incorrect OTP.",
                    "warning"
                );
            }
        } catch (err) {
            console.error(err);
            CustomSwal.fire(
                "Error",
                "OTP verification failed.",
                "error"
            );
        }
    };

    return (
        <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        ><div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content w-100">
                    <div className="modal-header">
                        <h4 className="modal-title text-center">
                            <strong>Contact Details Verification</strong>
                        </h4>
                    </div>

                    <div
                        className="modal-body mt-2"
                        style={{ fontFamily: "Segoe UI" }}
                    >
                        <div className="container-fluid">
                            {/* Email */}
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <div className="floating-label-group">
                                        <i className="fas fa-solid fa-envelope input-icon"></i>
                                        <input ref={emailRef} type="email" id="email" placeholder=" "
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            readOnly={emailStatus === "Y"} />
                                        <label htmlFor="email">
                                            Email
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-1"></div>
                                {emailStatus !== "Y" && (
                                    <div className="col-md-2">
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleSendOtp("email")}
                                        >
                                            Send OTP
                                        </button>
                                    </div>
                                )}
                                {emailStatus == "Y" && (
                                    <span className="text-success fw-bold">
                                        <i className="fas fa-check-circle me-1"></i>
                                        Email verified
                                    </span>
                                )}

                                <div className="form-group mt-1">
                                    <div className="row align-items-center">

                                        {showEmailOtp && (
                                            <>
                                                <div className="col-md-3">
                                                    <input
                                                        id="emailOtp"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={4}
                                                        placeholder="Enter Email OTP"
                                                        value={emailOtp}
                                                        onChange={(e) => setEmailOtp(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-md-2">
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => handleVerify("email")}
                                                    >
                                                        Verify
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                            </div>
                            <br></br>
                            {/* Mobile */}
                            <div className="form-group row mt-3">
                                <div className="col-md-6">
                                    <div className="floating-label-group">
                                        <i className="fas fa-solid fa-mobile-screen-button input-icon"></i>
                                        <input ref={mobileRef} type="text" id="mobileNo" placeholder=" " value={mobile}
                                            onChange={(e) => setMobile(e.target.value)}
                                            readOnly={mobileStatus === "Y"} />
                                        <label htmlFor="mobileNo" >
                                            Mobile No
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-1"></div>
                                {mobileStatus !== "Y" && (
                                    <div className="col-md-2 mt-1">
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => handleSendOtp("mobile")}
                                        >
                                            Send OTP
                                        </button>

                                    </div>
                                )}
                            </div>
                            {mobileStatus == "Y" && (
                                <span className="text-success fw-bold">
                                    <i className="fas fa-check-circle me-1"></i>
                                    Mobile number verified
                                </span>
                            )}
                            <div className="form-group mt-1">
                                    <div className="row align-items-center">

                                        {showMobileOtp && (
                                            <>
                                                <div className="col-md-3">
                                                    <input
                                                        id="mobileOtp"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={4}
                                                        placeholder="Enter Mobile OTP"
                                                        value={mobileOtp}
                                                        onChange={(e) => setMobileOtp(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-md-2">
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => handleVerify("mobile")}
                                                    >
                                                        Verify
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>


                        </div>
                    </div>

                    <div className="modal-footer">  

                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            Verify Later
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ContactVerification;